import React, { FC } from 'react'
import Modal from '../../common/Modal'
import { useTranslation } from 'react-i18next'
import { CompanyExternalApiKey, deleteCompanyExternalApiKeyRequest } from '../../../../states/types/setting'
import { Field, Form } from 'react-final-form'
import { useDispatch } from 'react-redux'
import { deleteCompanyExternalApiKey } from '../../../../states/apis/setting'
import { destroyCompanyExternalApiKey } from '../../../../states/containers/setting/companyExternalApiKeySlice'


interface DeleteExternalApiKeyModalState {
  isOpen: boolean,
  setIsOpen: (isOpen: boolean) => void,
}

interface Props {
  deleteExternalApiKeyModalState: DeleteExternalApiKeyModalState
  companyExternalApiKey: CompanyExternalApiKey
  closeCallback?: VoidFunction
  closeable?: boolean
}

interface DeleteExternalApiKeyModalFormData extends deleteCompanyExternalApiKeyRequest {
  label: string | undefined
  apiKey: string | undefined
  createdAt: string | undefined
  lastUsedAt: string | undefined
  creatorName: string | undefined
}

const DeleteExternalApiKeyModal: FC<Props> = (props) => {
  const {
    deleteExternalApiKeyModalState,
    companyExternalApiKey,
    closeCallback,
    closeable,
  } = props

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const initialValues: DeleteExternalApiKeyModalFormData = {
    id: companyExternalApiKey.id,
    label: companyExternalApiKey.label,
    apiKey: companyExternalApiKey.api_key,
    createdAt: companyExternalApiKey.created_at,
    lastUsedAt: companyExternalApiKey.last_used_at || '',
    creatorName: companyExternalApiKey.creator?.name,
  }

  const handleSubmit = (values: DeleteExternalApiKeyModalFormData) => {
    const requestData: deleteCompanyExternalApiKeyRequest = {
      id: values.id,
    }
    dispatch(destroyCompanyExternalApiKey(requestData,
      (response) => {
        closeCallback && closeCallback()
      }
    ))
  }

  const submitForm = () => {
    const form = document.forms.namedItem('delete_external_api_key')
    if (form) {
      form.dispatchEvent(
        new Event('submit', { cancelable: true, bubbles: true })
      )
    }
  }

  return (
    <Modal
      title="APIキーの削除"
      show={deleteExternalApiKeyModalState.isOpen}
      wrapperClass="setting_external_api_key"
      closeCallback={closeCallback}
      closeable={closeable}
    >
      {/* モーダルボディ */}
      <>
        <div className="api-key-instruction">
          こちらのAPIキーを削除します。
          削除したAPIキーは復元できませんので、あらかじめご了承ください。
        </div>

        <Form<DeleteExternalApiKeyModalFormData>
          onSubmit={handleSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, submitting, valid, pristine, errors }) => {
            return (
              <form name="delete_external_api_key" onSubmit={handleSubmit}>
                <Field
                  type="hidden"
                  name="id"
                  id="id"
                  component="input"
                  className="form-control"
                  initialValue={companyExternalApiKey.id}
                  readOnly
                  disabled
                />

                <div className="item">
                  <label htmlFor={t('model.externalApiKey.label')}>
                    <div className="title flex">
                      {t('model.externalApiKey.label')}
                    </div>
                  </label>
                  <div className="detail row_1">
                    <Field
                      type="text"
                      name="label"
                      id="label"
                      component="input"
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>

                <div className="item">
                  <label htmlFor={t('model.externalApiKey.createdAt')}>{t('model.externalApiKey.createdAt')}</label>
                  <div className="detail row_1">
                    <Field
                      type="text"
                      name="createdAt"
                      id="createdAt"
                      component="input"
                      className="form-control"
                      initialValue={companyExternalApiKey.created_at}
                      readOnly
                      disabled
                    />
                  </div>
                </div>

                <div className="item">
                  <label htmlFor={t('model.externalApiKey.lastUsedAt')}>{t('model.externalApiKey.lastUsedAt')}</label>
                  <div className="detail row_1">
                    <Field
                      type="text"
                      name="lastUsedAt"
                      id="lastUsedAt"
                      component="input"
                      className="form-control"
                      initialValue={companyExternalApiKey.last_used_at}
                      readOnly
                      disabled
                    />
                  </div>
                </div>
                <div className="item">
                  <label htmlFor={t('model.externalApiKey.creator')}>{t('model.externalApiKey.creator')}</label>
                  <div className="detail row_1">
                    <Field
                      type="text"
                      name="creatorName"
                      id="creatorName"
                      component="input"
                      className="form-control"
                      initialValue={companyExternalApiKey.creator?.name}
                      readOnly
                      disabled
                    />
                  </div>
                </div>
              </form>
            )
          }}
        />
      </>

      {/* モーダルフッター */}
      <>
        <button type="button" className="button cancel" onClick={closeCallback} disabled={!closeable}>
          キャンセル
        </button>
        <button
          type="button"
          className="button delete"
          onClick={submitForm}
        >
          削除する
        </button>
      </>
    </Modal>
  )
}

DeleteExternalApiKeyModal.defaultProps = {
  closeable: true,
}

export default DeleteExternalApiKeyModal
